import ApiHandler from "./ApiHandler";

const Password = {
  getReset: async (token) => await ApiHandler.i.get(`/password/reset/${token}`),
  postRequestReset: async (data, options) => await ApiHandler.i.post('/password/request-reset', data, options),
  postReset: async (data, options) => await ApiHandler.i.post('/password/reset', data, options),
};

export default Password;